// extracted by mini-css-extract-plugin
export default {"stepWrapper":"BsaSteps_stepWrapper__E6QXd"};